import { MerchantUserInformationDto } from "@/services/merchant/type";
import { useGetImage } from "@/utilities/helper/getImage";
import { Button, Container, Image, Stack, Text, Title } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Welcome() {
  const location = useLocation();
  const { merchant } = location.state;
  const merchantInfo = merchant as MerchantUserInformationDto;
  const { imageUrl } = useGetImage({
    image: merchantInfo?.merchantLogo,
    bucket: "merchant",
  });
  const navigate = useNavigate();
  return (
    <Container
      px="0"
      styles={{
        root: {
          background:
            "linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab)",
          backgroundSize: "400% 400%",
          animation: "gradient 15s ease infinite",
        },
      }}
    >
      <Stack mih="100svh" px="0">
        {/* <Header title="" showBack route="/dashboard/teams/teamMembers" /> */}
        <Container w="100%" size="md" px="md">
          <Stack flex={1} mih="100svh" justify="space-between">
            <Stack justify="center" align="center" mb="md" flex={1}>
              <Image
                src={imageUrl}
                h={100}
                w={100}
                radius="100%"
                fit="cover"
                fallbackSrc="https://placehold.co/100x100?text=%D9%BE%D8%AF%DB%8C%DA%A9%D8%B3"
              />
              <Title order={4}>{merchantInfo?.merchantTitle}</Title>
            </Stack>
            <Stack gap="xs" flex={1} align="center">
              <Title order={3}>به مجوعه خوش آمدید</Title>
              <Text size="sm" ta="justify">
                <Text span> اطلاعات شما به مجموعه اضافه شد </Text>
              </Text>
              <Button
                radius="xl"
                mt="lg"
                size="md"
                onClick={() => navigate("/dashboard")}
                leftSection={<IconArrowRight />}
              >
                ادامه
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </Container>
  );
}
